//@ts-nocheck

import React from 'react'

import { COLORS, Footnote, Spacer, TitleLarge } from 'ethos-design-system'
import PropTypes from 'prop-types'

import { HeaderByline } from '../Byline/Byline'
import Markdown, { MARKDOWN_NODE_RESTRICTION_SETS } from '../global/Markdown'
import headerStyles from './Header.module.scss'
import semiversatileStyles from './HeaderSemiversatile.module.scss'

export const HeaderSemiversatileTemplate = ({
  categoryLabel,
  displayCategoryLabel,
  heading,
  enableH1,
  subheading,
  linkToBio,
  displayAuthorName,
  authorBio,
  publishDate,
  displayPublishDate,
  backgroundColor = COLORS.WHITE.toLowerCase(),
  textColor = 'dark',
  authorsBase,
  customBottomPaddingPx,
}) => {
  const displayByline = displayAuthorName || displayPublishDate

  const headingElement = enableH1 ? 'h1' : 'div'
  const inheritedAuthor = authorsBase
    ? authorsBase.filter((obj) => {
        return obj.url === authorBio
      })[0]
    : undefined

  const inheritedAuthorName =
    inheritedAuthor && inheritedAuthor.pageLayout.length > 0
      ? inheritedAuthor.pageLayout[0].authorName
      : undefined

  const inheritedAuthorHeadshot =
    inheritedAuthor && inheritedAuthor.pageLayout.length > 0
      ? inheritedAuthor.pageLayout[0].headshot
      : undefined

  const inheritedAuthorAltText =
    inheritedAuthor && inheritedAuthor.pageLayout.length > 0
      ? inheritedAuthor.pageLayout[0].imageAlt
      : undefined

  const notOverrodeAuthor = !subheading

  const wrapperClasses = [headerStyles.Header__Wrapper, `bg-${backgroundColor}`]

  const headingTextColor =
    textColor === 'light' ? COLORS.WHITE : COLORS.GRAY_PRIMARY
  const supplementaryTextColor =
    textColor === 'light'
      ? COLORS.GRAY_STROKE_AND_DISABLED
      : COLORS.GRAY_SECONDARY

  return (
    <div className={wrapperClasses.join(' ')}>
      <div
        className={`${headerStyles.Header} ${semiversatileStyles.HeaderSemiVersatile}`}
      >
        <div
          className={semiversatileStyles.Header__Inner}
          style={
            customBottomPaddingPx !== undefined
              ? { paddingBottom: `${customBottomPaddingPx}px` }
              : undefined
          }
        >
          {displayCategoryLabel && (
            <React.Fragment>
              <Footnote.Medium500 allCaps color={supplementaryTextColor}>
                {categoryLabel}
              </Footnote.Medium500>
              <div className={semiversatileStyles.footnoteSpacer} aria-hidden />
            </React.Fragment>
          )}
          <TitleLarge.Serif.Book500
            element={headingElement}
            color={headingTextColor}
          >
            <Markdown
              input={heading}
              allowedMarkdownTypes={MARKDOWN_NODE_RESTRICTION_SETS.LINK_ONLY}
            />
          </TitleLarge.Serif.Book500>
          <div className={semiversatileStyles.titleSpacer} aria-hidden />
          {displayByline && (
            <React.Fragment>
              <Spacer.H16 />
              <HeaderByline
                authorName={
                  subheading
                    ? subheading
                    : displayAuthorName
                    ? inheritedAuthorName
                    : undefined
                }
                date={
                  displayPublishDate && publishDate
                    ? new Date(publishDate)
                    : undefined
                }
                link={
                  notOverrodeAuthor && linkToBio && authorBio
                    ? '/author-bio/' + authorBio
                    : undefined
                }
                image={displayAuthorName ? inheritedAuthorHeadshot : undefined}
                imageAlt={
                  displayAuthorName ? inheritedAuthorAltText : undefined
                }
                color={supplementaryTextColor}
              />
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  )
}

HeaderSemiversatileTemplate.propTypes = {
  categoryLabel: PropTypes.string,
  displayCategoryLabel: PropTypes.bool,
  heading: PropTypes.string,
  enableH1: PropTypes.bool,
  subheading: PropTypes.string,
  linkToBio: PropTypes.bool,
  displayAuthorName: PropTypes.bool,
  authorBio: PropTypes.string,
  publishDate: PropTypes.string,
  displayPublishDate: PropTypes.bool,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
}

const HeaderSemiversatile = ({ moduleData, authorBio }) => {
  return <HeaderSemiversatileTemplate {...moduleData} authorsBase={authorBio} />
}

HeaderSemiversatile.propTypes = {
  moduleData: PropTypes.shape(HeaderSemiversatileTemplate.propTypes),
}

export default HeaderSemiversatile
